<template>
  <div class="new-league-list" :class="{ 'is-mobile': isMobile, 'is-electron': $isElectron }">
    <div class="inner-scroll">
      <div class="left-side-image" v-if="featuredItemsLength > 0" :class="activeMenu.icon">
        <div class="left-side-menu-icon"></div>
      </div>
      <div
        class="media-featured-links"
        v-if="featuredItemsLength > 0"
        :class="{
          'has-see-all-links': showSeeAll,
        }"
      >
        <div class="media-list-header">
          <h2 class="media-list-header-title">{{ activeMenu.display_name }}</h2>
          <h3 class="media-list-header-sub-title">{{ featuredItems.display_name }}</h3>
        </div>
        <div
          class="media-list-body"
          :class="{
            'has-see-all': showSeeAll,
          }"
        >
          <div
            class="link-item"
            v-for="(sub, index) in featuredItemsSliced.children.filter(item => item.visible)"
            :key="sub.id + '_' + index"
            :class="{
              active: activeNav.id === sub.id,
            }"
            @click="_selectLeague(sub)"
          >
            {{ sub.display_name }}
          </div>
        </div>
        <div v-if="showSeeAll" class="see-all-area-container">
          <div class="see-all-area" :class="{ 'is-sliced': isSliced }" @click="isSliced = !isSliced">
            <span class="text">{{ isSliced ? $t('See All') : $t('See Less') }}</span>
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1.21936 4.21967C0.940416 3.92678 0.488155 3.92678 0.209209 4.21967C-0.0697365 4.51256 -0.0697366 4.98744 0.209209 5.28033L4.49492 9.78033C4.76534 10.0643 5.20075 10.0742 5.48266 9.80286L9.76837 5.67787C10.0592 5.39797 10.0788 4.92355 9.81225 4.61821C9.54568 4.31287 9.09385 4.29224 8.80305 4.57214L5.02148 8.2119L1.21936 4.21967Z"
                fill="#ED6706"
              />
              <path
                opacity="0.3"
                d="M1.21936 0.183057C0.940416 -0.0610207 0.488156 -0.0610208 0.20921 0.183057C-0.0697358 0.427135 -0.0697359 0.822863 0.20921 1.06694L4.49492 4.81694C4.76534 5.05355 5.20075 5.06183 5.48266 4.83572L9.76837 1.39822C10.0592 1.16498 10.0788 0.769621 9.81225 0.515172C9.54568 0.260722 9.09385 0.243533 8.80305 0.476778L5.02148 3.50991L1.21936 0.183057Z"
                fill="#ED6706"
              />
            </svg>
          </div>
        </div>
      </div>
      <div
        class="media-list pt-0 pl-0 pr-0 left-side-bottom"
        v-if="countriesLength > 0"
        :class="{
          'no-features mt-4': featuredItemsLength === 0,
        }"
      >
        <div class="media-list-header" style="padding: 0 1rem;">
          <h3 class="title sub-title mb-3">{{ countries.display_name }}</h3>
        </div>

        <MenuAccordion
          :ref="'countryRef_' + sub.id"
          v-for="(sub, index) in countries.children.filter(item => item.visible)"
          :key="sub.id + '_' + index"
          :item="sub"
          :groupId="sub.id + '_' + index"
          :title="sub.display_name"
          :is-opened="isOpened(sub)"
        >
          <template slot="title">
            <img v-if="sub.icon" :src="`${$cdn}/svgs/flags/${sub.icon}.svg`" class="mr-2" width="22" alt />
            {{ sub.display_name }}
          </template>
          <template slot="content">
            <div
              class="sub-item-list-item"
              :class="activeLeagueId === leg.league_id ? 'active' : ''"
              :id="'legId_' + leg.id"
              v-for="leg in sub.children.filter(f => f.visible)"
              :key="leg.id"
            >
              <a href="javascript:;" class="item-link" @click="_selectLeague(leg, true, sub)">{{ leg.display_name }}</a>
            </div>
          </template>
        </MenuAccordion>
      </div>
    </div>
  </div>
</template>

<script>
import { leagueListMixin } from '../mixins/league-list-mixin';
import MenuAccordion from './MenuAccordion';
import snq from 'snq';
import Vue from 'vue';
export default {
  name: 'league-list',
  components: { MenuAccordion },
  mixins: [leagueListMixin],
  props: ['isMobile'],
  data() {
    return {
      isSliced: true,
      sliceCount: 6,
    };
  },
  methods: {
    _selectLeague(leg, withCountry, country) {
      this.selectLeague(leg);
      if (withCountry) {
        this.clearSelectedMarkets();
        this.setActiveCountry(country.id);
      }
      this.$emit('clicked', leg);
    },
    smoothScroll(item) {
      if (!item) {
        return;
      }
      let scrollWrapper = document.querySelector('.mll-modal .modal__container');
      const elementPosition = item.getBoundingClientRect().top;
      const offsetPosition = elementPosition - 47;

      scrollWrapper.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    },
    isOpened(sub) {
      const children = snq(() => sub.children || []) || [];
      return children.map(item => item.id).includes(this.activeNav.id);
    },
  },
  computed: {
    activeMenuChildren() {
      return this.activeMenu.children;
    },
    featuredItemsSliced() {
      let main = this.featuredItems;
      if (this.isSliced) {
        main = {
          ...main,
          children: main.children.slice(0, this.sliceCount),
        };
      }
      return main;
    },
    featuredItems() {
      return this.activeMenu.children.find(item => item.icon.toLowerCase() === 'featured' && item.visible);
    },
    featuredItemsLength() {
      return snq(() => this.featuredItems.children.length);
    },
    countries() {
      return this.activeMenu.children.find(item => item.icon.toLowerCase() === 'countries' && item.visible);
    },
    countriesLength() {
      return snq(() => this.countries.children.length);
    },
    showSeeAll() {
      return this.featuredItemsLength > this.sliceCount;
    },
  },
  mounted() {
    this.$nextTick().then(() => {
      if (this.isMobile) {
        if (this.activeNav) {
          const el = document.getElementById(`legId_${this.activeNav.id}`);
          this.smoothScroll(el);
        }
      }
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
@import '@/sass/pages/components/league-list-new.scss';
</style>
